<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="eId"
        @select="selectTest"
        @select-all="selectAll">
      <!-- <div slot="toolbar">
        <el-button
            type="primary"
            @click="$refs.editDistrict.open(0)">
          新建
        </el-button>
        <el-button
            type="danger"
            @click="deleteIds">
          批量删除
        </el-button>
      </div> -->
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="电子ID">
            <el-input v-model.trim="filter.eID" clearable/>
          </vm-search>
          <vm-search label="序列号(条码)">
            <el-input v-model.trim="filter.serialNo" clearable/>
          </vm-search>
          <vm-search label="操作人">
            <el-input v-model.trim="filter.exportOperatorName" clearable/>
          </vm-search>
          <vm-search label="接收方">
            <el-input v-model.trim="filter.exportToName" clearable/>
          </vm-search>
          <vm-search label="采集人">
            <el-input v-model.trim="filter.collector" clearable/>
          </vm-search>
          <vm-search label="采集组织">
            <el-input v-model.trim="filter.collectOrgan" clearable/>
          </vm-search>
          <vm-search label="采集时间">
            <div class="block">
              <!--              <el-date-picker-->
              <!--                  v-model="scope.row.beginTime"-->
              <!--                  type="datetime"-->
              <!--                  value-format="yyyy-MM-dd HH:mm:ss"-->
              <!--                  placeholder="选择日期"/>-->
              <el-date-picker
                  v-model="filter.starCollectTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 190px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCollectTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
          <vm-search label="创建人">
            <el-input v-model.trim="filter.creatorName" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.starCreateTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 190px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column width="70" prop="eid" align="center" label="电子ID"/>
      <el-table-column prop="serialNo" align="center" label="序列号"/>
      <el-table-column prop="boardType" align="center" label="板卡类型"/>
      <el-table-column prop="collectTime" align="center" label="采集时间"/>
      <el-table-column prop="collectOrgan" align="center" label="采集组织"/>
      <el-table-column width="70" prop="collector" align="center" label="采集人"/>
      <el-table-column prop="createTime" align="center" label="创建时间"/>
      <el-table-column prop="createType" align="center" label="创建方式"/>
      <el-table-column width="70" prop="creatorName" align="center" label="创建人"/>
      <el-table-column prop="status" align="center" label="状态">
        <template slot-scope="scope">
          {{constant.electronicStatus[scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column prop="exportTime" align="center" label="导出时间"/>
      <el-table-column width="70" prop="exportOperatorName" align="center" label="操作人"/>
      <el-table-column width="70" prop="exportTo" align="center" label="接收方"/>
      <el-table-column prop="exportNote" align="center" label="导出备注"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="90px">
        <template slot-scope="scope">
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          <!--<el-button type="primary" @click="$refs.editDistrict.open(scope.row.districtID)">编辑</el-button>-->
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  export default {
    name: "Electronic",
    components: {VmTable, VmSearch},
    data() {
      return {
        constant,
        idList: "",
        filter: {
          eID: "",
          serialNo: "",
          exportOperatorName: "",
          exportToName: "",
          //采集
          collector:"",
          collectOrgan:"",
          starCollectTime:"",
          endCollectTime:"",
          //创建
          creatorName:"",
          starCreateTime:"",
          endCreateTime:"",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      // //批量删除
      // deleteIds() {
      //   if(this.idList.length) {
      //     let ids = [];
      //     for (let item of this.idList) {
      //       ids.push(item.districtID);
      //     }
      //     //console.log(ids);
      //     this.$http
      //       .delete("basic","districts/idList",ids).then(() => {
      //         this.getList(-1);
      //         this.$message.success("删除成功");
      //         this.idList = "";
      //       });
      //   }else{
      //     this.$message.error("请选择要删除的内容");
      //   }
      //
      // },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","eId",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
